import React, { useCallback, useMemo } from 'react';
import { InputAdornment, Icon, Select } from '@picsio/ui';
import Logger from '../../../../services/Logger';
import OPTIONS from './options';
import Option from './Option';
import styles from './styles.module.scss';

const menuProps = {
  MenuListProps: { className: styles.list },
};

const renderValue = (selected) => (
  selected
    ? OPTIONS.find(({ value: optionValue }) => optionValue === selected).text
    : selected
);

function ViewsSelector({
  value, onChange, assetId, assetName,
}) {
  const icon = useMemo(() => {
    const option = OPTIONS.find(({ value: optionValue }) => optionValue === value);
    if (!option) return null;
    return (
      <InputAdornment position="start">
        <Icon size="sm">
          {option.icon}
        </Icon>
      </InputAdornment>
    );
  }, [value]);

  const handleChange = useCallback((e) => {
    const { value: selectValue } = e.target;
    onChange(selectValue);

    const option = OPTIONS.find(({ value: optionValue }) => optionValue === selectValue);
    if (!option) return;

    Logger.log('User', option.amplitudeEventName, {
      assetId,
      assetName,
      initiation_location: 'video and audio ai tab',
    });
  }, [onChange, assetId, assetName]);

  return (
    <div className={styles.wrapper}>
      <Select
        className={styles.select}
        name="views-selector"
        options={OPTIONS}
        dataId="value"
        dataText="text"
        value={value}
        onChange={handleChange}
        renderValue={renderValue}
        optionComponent={Option}
        startAdornment={icon}
        MenuProps={menuProps}
      />
    </div>
  );
}

export default ViewsSelector;
